
      window.ri2 = {
        getUserId: () => null,
        addItemsToCart: (items, caseId) => {
          console.log("addItemsToCart: ", items, caseId)
        },
      }
    